import { beeTypes } from '@beefree.io/sdk';
import api from './api';

interface BeeAuthResponse {
  access_token?: string;
  v2?: boolean;
}

export async function getBeeToken(
  uid: string
): Promise<beeTypes.IToken | null> {
  const response = await api.post<BeeAuthResponse>('/bee/auth/pages', { uid });

  if (!response.data?.access_token) {
    return null;
  }

  return {
    access_token: response.data.access_token,
    v2: response.data.v2 ?? true,
    status: beeTypes.TokenStatus.OK
  };
}
